import { Commit } from 'vuex';
import { SuiviFacturesPayeesState } from './state';

export enum SuiviFacturesPayees {
    GET_SUIVI_FACTURES_PAYEES = 'GET_SUIVI_FACTURES_PAYEES',
    GET_FACTURES_PAYEES_PDF = 'GET_FACTURES_PAYEES_PDF'
}

export interface SuiviFacturesPayeesActionTypes {
    commit: Commit,
    state: SuiviFacturesPayeesState,
    getters: any
}
